import { useSelector } from 'react-redux';
import { selectDoesUserHaveAccessCheck } from 'core/userContext';

import { SubHeader } from './QuickNav.styles';
import { SecondaryOption } from './SecondaryOption';
import { LinkSubsectionLink } from '../types';

export interface LinkSubsectionProps {
  /** Displayed Text */
  title: string;
  /** Links Array */
  links?: LinkSubsectionLink[];
}

export const LinkSubsection = ({ title = '', links = [] }: LinkSubsectionProps) => {
  const doesUserHaveAccess = useSelector(selectDoesUserHaveAccessCheck);

  return (
    <>
      <SubHeader key={title} data-test="quick-nav-subheader-linksubsection">
        {title}
      </SubHeader>
      {links.map(
        (
          {
            label = '',
            href = '',
            permission,
            featureFlags = [],
            rbacPermission = [],
            hideFromProspect,
          },
          idx,
        ) =>
          doesUserHaveAccess(permission, featureFlags, rbacPermission, hideFromProspect) && (
            <SecondaryOption
              data-test={`quick-nav-linksubsection-link-${idx}`}
              key={label + idx}
              href={href}
              title={label}
            />
          ),
      )}
    </>
  );
};
